export default "__VITE_ASSET__a0edb045__"